export default {
  "failed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログアウトに失敗しました"])}
}